import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useMediaQuery } from '@material-ui/core'
import { useDashboardSettings } from '../GenericWheelProvider'
import { useDashboardNavigation } from '../NavigationProvider/context'
import { useSetShowHeaderBackButton } from '../../../../redux/slices/appContext'
import DashboardTile from '../components/DashboardTile'
import DashboardLayout from './DashboardLayout'

const WheelLayout = ({ logo, children }) => {
  const { items, highlightedView, changeHighlightedView } = useDashboardSettings()
  const setShowHeaderBackButton = useSetShowHeaderBackButton()
  const navMan = useDashboardNavigation()
  const isSmall = useMediaQuery('(max-width: 960px)')

  useEffect(() => {
    setShowHeaderBackButton(false)
  }, [setShowHeaderBackButton])

  if (isSmall) {
    return (
      (
        <DashboardLayout className='p-sm' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 'var(--gap-sm)' }}>
          {children ? (
            <div
              className={clsx('transition-opacity transition-delay-long transition-1s', { 'opacity-lowlighted': highlightedView })}
            >
              {children}
            </div>
          ) : null}
          {items.filter(x => !x.hidden).map((item) => (
            <DashboardTile
              layout={isSmall ? 'linear' : 'circular'}
              key={item.key}
              viewKey={item.key}
              position={navMan.getViewPosition(item.key)}
              lowlighted={highlightedView ? highlightedView !== item.key : false}
              highlighted={highlightedView === item.key}
              onHoverChange={changeHighlightedView}
              {...item}
            />
          ))}
          <div style={{ minHeight: '100px' }}>&nbsp;</div>
        </DashboardLayout>
      )
    )
  }

  return (
    <DashboardLayout>
      {children ? (
        <div
          className={clsx('absolute transition-opacity transition-delay-long transition-1s', { 'opacity-lowlighted': highlightedView })}
          style={{
            left: '50%',
            transform: 'translate3d(-50%, -50%, 0)',
            top: '50%'
          }}
        >
          {children}
        </div>
      ) : null}
      {items.filter(x => !x.hidden).map((item) => (
        <DashboardTile
          layout='circular'
          key={item.key}
          viewKey={item.key}
          position={navMan.getViewPosition(item.key)}
          lowlighted={highlightedView ? highlightedView !== item.key : false}
          highlighted={highlightedView === item.key}
          onHoverChange={changeHighlightedView}
          {...item}
        />
      ))}
      {logo || null}
    </DashboardLayout>
  )
}

WheelLayout.propTypes = {
  children: PropTypes.node,
  logo: PropTypes.node
}

export default WheelLayout
